/* import __COLOCATED_TEMPLATE__ from './account-details-modal.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { feature } from '@square/ember-features/macros';
import { formatNumber } from '@banking/ui/utils/checking/utils';
import BankingToastComponent from '@banking/ui/components/banking/toast';
const ROUTING_NUMBER_INDICES = [6, 3];
const ACCOUNT_NUMBER_INDICES = [9, 6, 3];
let AccountDetailsModal = (_dec = feature('deposits/enable_direct_deposit_account_limit'), (_class = class AccountDetailsModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "flash", _descriptor2, this);
    _initializerDefineProperty(this, "canViewDirectDepositLimit", _descriptor3, this);
    _initializerDefineProperty(this, "directDepositAccount", _descriptor4, this);
    _initializerDefineProperty(this, "directDepositLimit", _descriptor5, this);
  }
  get accountNumber() {
    return formatNumber(this.args.directDepositAccount.accountNumber, ACCOUNT_NUMBER_INDICES);
  }
  get routingNumber() {
    return formatNumber(this.args.directDepositAccount.routingNumber, ROUTING_NUMBER_INDICES);
  }
  showCopyFailedToast() {
    this.flash.globalWarning(this.intl.t('banking.components.accountDetailsCard.copyFailed'), {
      flashComponent: BankingToastComponent,
      dismiss: this.dismiss,
      componentOptions: {
        dismissLabel: this.intl.t('banking.shared.toast.dismiss')
      }
    });
  }
  showCopySuccessToast(key) {
    this.flash.globalSuccess(this.intl.t(key), {
      flashComponent: BankingToastComponent,
      dismiss: this.dismiss,
      componentOptions: {
        dismissLabel: this.intl.t('banking.shared.toast.dismiss')
      }
    });
  }
  async copyAccountNumber() {
    const clipboard = window.navigator?.clipboard;
    if (!clipboard?.writeText || !this.accountNumber) {
      this.showCopyFailedToast();
      return;
    }
    try {
      await clipboard.writeText(this.accountNumber.replace(/\s/g, ''));
      this.showCopySuccessToast('banking.components.accountDetailsCard.accountNumber.copied');
    } catch {
      this.showCopyFailedToast();
    }
  }
  async copyRoutingNumber() {
    const clipboard = window.navigator?.clipboard;
    if (!clipboard?.writeText || !this.routingNumber) {
      this.showCopyFailedToast();
      return;
    }
    try {
      await clipboard.writeText(this.routingNumber.replace(/\s/g, ''));
      this.showCopySuccessToast('banking.components.accountDetailsCard.routingNumber.copied');
    } catch {
      this.showCopyFailedToast();
    }
  }
  dismiss() {
    return this.flash.clearGlobalMessage();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flash", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canViewDirectDepositLimit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "directDepositAccount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.directDepositAccount;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "directDepositLimit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.directDepositLimit;
  }
}), _applyDecoratedDescriptor(_class.prototype, "copyAccountNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyAccountNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyRoutingNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyRoutingNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype)), _class));
export { AccountDetailsModal as default };